import React from 'react'
import './navbar.scss'

function Navbar() {
   const items = [
      {
         label: 'About',
         path: '/#about',
      },
      {
         label: 'Skills',
         path: '/#skills',
      },
      {
         label: 'Work',
         path: '/#work',
      },
      {
         label: 'Contact',
         path: '/#contact',
      },
   ]
   return (
      <div className="navbar">
         <div className="navbar__wrapper">
            <div className="navbar__wrapper--logo">
               <a href="/">
                  <img src="/svg/logo-black.svg" alt="newtou" />
               </a>
            </div>
            <div className="navbar__wrapper--links">
               {items.map((item, index) => (
                  <a
                     key={index}
                     className="navbar__wrapper--links-item"
                     href={item.path}>
                     {item.label}
                  </a>
               ))}
            </div>
         </div>
      </div>
   )
}

export default Navbar
